import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { ACCOUNT_MANAGER_REPORT_ID } from './accountManagerReportId';

const emptyColumns = [FIELDS.ACCOUNT_MANAGER].map(createFooterMapper(ACCOUNT_MANAGER_REPORT_ID));

const reportFooterColumnDefinition = [...emptyColumns];

export default reportFooterColumnDefinition;
